import React from 'react';
import RowButton from './RowButton';
import { useLocale } from './../special/LanguageProvider';


const RowDeleteButton = ( { onClick = null }) => {
  const {t} = useLocale();
  return (
      <RowButton tooltip={t("Eyða")} iconclass={"icon-remove2 no-text"} onClick={onClick} />
  );
}


export default RowDeleteButton;